const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the Sign In Directive which defines the sign in form behavior and markup
 * @argument {Passcode} Users injected to access the Passcode resource
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('resetPassword', ['Users', 'Application', 'Authorization', '$location', '$translate', function (Users, Application, Authorization, $location, $translate) {
  return {
    restrict: 'E',
    template: require('../../../templates/directives/preauth/reset-password.html'),
    controller: function () {
      var self = this;
      var params = Application.navigation.getUrlParameters();
      var url = Application.navigation.getUrl();
      if (!params.key || url.indexOf('resetpassword') === -1) {
        return;
      }
      self.displaySuccess = false;
      self.credentials = {key: params.key, password: ''};
      self.loading = false;

      self.pressEnter = function(keyPress) {
        if (self.loading || keyPress !== 'click' && keyPress.which !== 13) {
          return;
        }

        if (!self.credentials.password || self.credentials.password.length < 5 || self.credentials.password !== self.confirmPassword) {
          Application.messaging.addMessage({type: 'error', text: self.translations['preauth.resetpassword.password_match_error'], duration: 7});
          return;
        }

        if (self.credentials.email && self.credentials.password) {
          self.submitPassword();
        }
      };
      self.goToLogin = function() {
        Application.navigation.goTo('signin');
        $location.search('key', null);
      };
      self.submitPassword = function () {
        var domain = Application.companyDomain;
        self.loading = true;
        Users.singleresetting({subresource: self.credentials.email}, {domain: domain}, function (data) {
          self.loading = false;
          self.displaySuccess = true;
        }, function (error) {
          self.loading = false;
          Application.messaging.addMessage({type: 'error', text: self.translations['preauth.resetpassword.link_not_valid'], duration: 20});
          Authorization.clearAuthToken();
          console.log('Error', error);
          Application.notifications.setError(self.translations['modules.notifications.invalidCredentials']);
        });
      };

      $translate([
        'modules.notifications.invalidCredentials',
        'preauth.resetpassword.password_match_error',
        'preauth.resetpassword.link_not_valid'
      ]).then(function(data){
        self.translations = data;
      });

    },
    controllerAs: 'resetPass'
  };
}]);
